






import CloseButton from '@/components/CloseButton.vue'
import PasswordResetForm from '@/components/PasswordResetForm.vue'
import Vue from 'vue'
export default Vue.extend({
    components: { CloseButton, PasswordResetForm }
})
